export const downloadDataAsCSVFile = (data, fileName = 'my-file.csv') => {
  const blob = new Blob([data], {type: 'text/csv;charset=utf-8;'})
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
